import { Box, ButtonNew as Button, ModalDialogNew, Spacer, Text, TextProps } from '@jfs/ui-new'
import { Icon } from '@jfs/ui-new/src/comps/IconNew'
import { Title } from '../Title'

interface InactivityDialogProps {
  show: boolean
  message: string
  type: any
  onPress: any
}

export const InactivityDialog = ({ show, message, type, onPress }: InactivityDialogProps) => {
  return (
    <ModalDialogNew type={'bottom'} show={show} backgroundColor="TRANSPARENT">
      <Box
        flexDirection={'column'}
        ph={48}
        pt={48}
        pb={8}
        borderTopLeftRadius={24}
        borderTopRightRadius={24}
        alignItems={'center'}
        backgroundColor={'WHITE'}>
        <Box
          width={32}
          height={32}
          borderRadius={32}
          backgroundColor={type === 'POSITIVE' ? 'BRAND_PRIMARY_GREEN' : 'BRAND_PRIMARY_RED'}
          justifyContent="center"
          alignItems={'center'}>
          <Icon id="CLOSE" size={20} color={'WHITE'} />
        </Box>
        <Spacer size={24} />
        <Title title={message} color="BLACK_75" />
        <Spacer size={8} />
        <Button
          type={'secondary'}
          onPress={onPress}
          borderColor={'TRANSPARENT'}
          underlayColor={'TRANSPARENT'}
          children={
            <Text
              {...styles.secondaryButtonText}
              color={type === 'POSITIVE' ? 'BRAND_PRIMARY_GREEN' : 'BRAND_PRIMARY_RED'}>
              OK
            </Text>
          }
        />
      </Box>
    </ModalDialogNew>
  )
}

const styles = {
  secondaryButtonText: {
    fontSize: 14,
    fontFamily: 'jioType-medium',
    color: 'BRAND_PRIMARY_RED',
  } as TextProps,
}
